export default __webpack_public_path__ + "static/media/zappos.48761062.png";